export default __webpack_public_path__ + "static/media/Talent_BiggerAndBetter.a00b2892.png";